<template>
  <div id="top">
    <div v-show="isPage === 'firstLabel'" class="containerFirstLabel">
      <div style="display: flex; justify-content: center; margin: 50px; flex-direction: column; align-items: center;" v-if="labelList.length == 0">
        <img src="../emptyList.png" alt="" />
        <span style="color: #888; font-size: 18px;">暂无事项</span>
      </div>
      <div v-for="children in labelList" :key="children.iid">
        <div class="oneTitle" :id="children.labelId">
          <div class="oneTitleText">{{ children.labelName }}</div>
          <!-- <div class="viewMore" @click="readMoreHandle(children)"><a class="blackA">查看更多<a-icon :component="arrow" style="margin-left: 5px;" /></a></div> -->
        </div>
        <div class="firstBox" :key="children.iid">
          <template v-for="(label, index) in children.children">
            <div class="cardLabel" :key="label.iid" v-if="index < 8">
              <div class="twoTitle">
                <div style="line-height: 28px;">
                  <img
                    class="imgClass"
                    :src="label.iconUrl || noImg"
                    width="28px"
                    alt=""
                  /></div>
                <p class="twoTitleText">
                  <a class="blackA" :id="label.labelId">
                    <a-tooltip placement="top" :title="label.labelName">
                      <p @click="clickTwoLabel(label.labelId, label.labelName, label)" class="overFlowText">{{ label.labelName }}</p>
                    </a-tooltip>
                  </a>
                </p>
              </div>
              <template>
                <a-tooltip v-for="(item, index2) in label.relatedItemList" placement="left" :title="item.itemName" :key="item.iid">
                  <div @click="toOneThingGuide(item.iid, item.itemName, item)" class="labelName" v-if="index2 < 5"><a><p class="overFlowText">{{ item.itemName }}</p></a></div>
                </a-tooltip>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- <TwoLevelLabelVue ref="TwoLevelLabelVue" v-show="isPage === 'twoLabel'" @backHandle="backFirstLabel"></TwoLevelLabelVue> -->
    <!-- <MatterList ref="matterList" v-show="isPage === 'matterList'" @backLabel="backFirstLabel"></MatterList> -->
    <HotServicesLevel2Page ref="matterList" v-show="isPage === 'matterList'" @backLabel="backFirstLabel"></HotServicesLevel2Page>
  </div>
</template>

<script>
import { jiopWebAPI } from '@/api/jiopweb/jiopweb.js'
import arrow from '../arrow.svg?inline'
import noImg from '../noImg.svg'
import TwoLevelLabelVue from '@/views/jiopweb/singleEventList/components/TwoLevelLabel.vue'
import MatterList from '@/views/jiopweb/singleEventList/components/MatterList.vue'
import HotServicesLevel2Page from './HotServicesLevel2Page.vue'
export default {
  name: 'Label',
  components: {
    TwoLevelLabelVue,
    MatterList,
    HotServicesLevel2Page
  },
  props: {
    districtId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      arrow,
      noImg,
      labelList: [],
      isPage: 'firstLabel'
    }
  },
  created () {
    this.init() // 父组件会在获取到地区id之后调用
  },
  methods: {
    init (labelId) {
      jiopWebAPI.findByDistrictCode({ districtCode: this.$route.query.areaCode, serviceObj: this.$route.query.bannerType === 'legalperson' ? 'legalperson' : 'personal' }).then(res => {
        this.labelList = res.data.labelList
        console.log('labelList=-=---', this.labelList)
        if (labelId) {
          this.isPage = 'firstLabel'
          setTimeout(() => {
            document.getElementById(`${labelId}`).scrollIntoView({
              behavior: 'smooth', // 平滑过渡
              block: 'start' // 上边框与视窗顶部平齐
            })
          }, 500)
        }
      })
    },
    readMoreHandle (children) {
      this.scrollTop()
      this.$refs.TwoLevelLabelVue.init(children.labelId, children.labelName)
      this.isPage = 'twoLabel'
    },
    toOneThingGuide (value, name, itt) {
      sessionStorage.setItem('matter_name', itt.oneThingName)
      const url = this.$router.resolve({ path: '/guideSimple', query: { itemId: value, bannerType: this.$route.query.bannerType } })
      window.open(url.href, '_blank')
    },
    clickTwoLabel (labelId, labelName, serviceData) {
      this.$refs.matterList.init(labelId, labelName, serviceData)
      this.isPage = 'matterList'
    },
    backFirstLabel (id) {
      console.log(id)
      this.isPage = 'firstLabel'
      setTimeout(() => {
        document.getElementById(`${id}`).scrollIntoView({
          behavior: 'smooth', // 平滑过渡
          block: 'start' // 上边框与视窗顶部平齐
        })
      }, 500)
    },
    scrollTop () {
      setTimeout(() => {
        document.getElementById('top').scrollIntoView({
          behavior: 'smooth', // 平滑过渡
          block: 'start' // 上边框与视窗顶部平齐
        })
      }, 0)
    }
  }
}
</script>

<style scoped lang="less">
a {
  color: rgba(89, 89, 89, 1);
}
a:hover {
  color: #4393F5;
}
.blackA {
  color: rgba(89, 89, 89, 1) !important;
}
.overFlowText {
  width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.containerFirstLabel {
  width: 1300px;
  margin: auto;
  padding-top: 30px;
  padding-left: 50px;
}
.viewMore {

  font-size: 16px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
  height: 30px;
  line-height: 30px;
  margin-right: 50px;
}
.firstBox {
  display: flex;
  flex-wrap: wrap;
}
.oneTitle {
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: space-between;
}
.oneTitleText {

  font-size: 22px;
  color: #333333;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 600;
}
.cardLabel:hover {
  background-color: #EAF3FF;
  border: 1px #EAF3FF solid;
}
.cardLabel {
  width: 278px;
  height: 230px;
  border: 1px  rgba(238,238,238,1) solid;
  margin-bottom: 30px;
  margin-right: 30px;

  .twoTitle {
    margin-left: 20px;
    margin-top: 20px;
    margin-bottom: 8px;
    height: 30px;
    padding: 0px;
    display: flex;
    .twoTitleText {

      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 600;
      padding: 0px;
      padding-left: 16px;
      padding-bottom: 0;
      height: 22px;
      line-height: 30px;
    }
  }

  .labelName {

    font-size: 14px;
    letter-spacing: 0;
    font-weight: 400;
    color: #666666;
    height: 28px;
    line-height: 28px;
    margin-left: 36px;
  }
}
</style>
